import allytm from '@ally/allytm'

export interface KeyValuePairObj {
  [key: string]: string
}

export function fireErrorTagging(errors: KeyValuePairObj): void {
  Object.entries(errors).forEach(error =>
    allytm.event('customError', `${error[0]}: ${error[1]}`),
  )
}
